import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SUPPLIERBANK_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SupplierBank.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SupplierBank.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const SUPPLIERBANK_CONFIG = {
  entityName: 'SupplierBank',
  localizationKey: 'Controlling::Entity.SupplierBank',
  fields: SUPPLIERBANK_FIELDS,
  permission: 'ControllingContract.SupplierBanks',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
